// extracted by mini-css-extract-plugin
module.exports =  {"skeletonList":"skeletonList_Rf3FvUa2","skeletonRow":"skeletonRow_nlDkU4CD"};